<template>
    <div id="app" class="d-flex flex-column h-100 main-container">
        <b-navbar toggleable="md" class="flex-shrink-0 border-bottom site-navbar">
            <b-navbar-brand class="p-0 col-2 mr-0">
                <router-link to="/login"><img src="@/assets/qiwi-logo.png"></router-link>
            </b-navbar-brand>
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse">
                <menu-items></menu-items>
                <b-navbar-nav :class="!$store.getters.isLoggedIn ? 'ml-auto justify-content-end' : 'ml-auto mr-3 justify-content-end'">
                    <b-nav-item to="/help" :title="$t('menu.help')">
                        <help-icon title="" />&nbsp;{{ $t('menu.help') }}
                    </b-nav-item>
                    <b-nav-item-dropdown class="text-nowrap" :title="$store.getters.locale.toUpperCase()">
                        <template slot="button-content">
                            <earth-icon title="" />&nbsp;{{ $store.getters.locale.toUpperCase() }}
                        </template>
                        <b-dropdown-item-btn @click="setLang">KZ</b-dropdown-item-btn>
                        <b-dropdown-item-btn @click="setLang">EN</b-dropdown-item-btn>
                        <b-dropdown-item-btn @click="setLang">RU</b-dropdown-item-btn>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
                <b-navbar-nav v-show="$store.getters.isLoggedIn">
                    <b-nav-item-dropdown id="personDropdown" right>
                        <template slot="button-content">
                            <div class="d-inline-block text-truncate" style="max-width: 300px;" :title="displayName">
                                {{ displayName }}<br>
                                ({{ userRoleDisplay }})
                            </div>
                        </template>
                        <b-dropdown-item to="/profile"><account-icon title="" />&nbsp;{{ $t('menu.profile') }}</b-dropdown-item>
                        <b-dropdown-item-btn @click="logout"><logout-icon title="" />&nbsp;{{ $t('general.quit') }}</b-dropdown-item-btn>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <div class="d-flex flex-grow-1">
            <router-view :key="$route.fullPath"></router-view>
            <vue-progress-bar></vue-progress-bar>
        </div>
        <b-container class="site-footer text-muted no-print" fluid>
            <b-row class="d-flex justify-content-between">
                <b-col/>
                <b-col>© QIWI Kazakhstan 2019</b-col>
                <b-col class="d-flex justify-content-end">
                    <span>{{ $t('version.client') }} {{clientVersion}}, {{$t('version.server')}} {{serverVersion}}</span>
                </b-col>
            </b-row>            
        </b-container>
    </div>
</template>
<script>
/* eslint-disable */
import MenuItems from '@/components/general/MenuItems.vue'
import { Version } from './Version';

export default {
    name: 'app',
    components: {
        MenuItems
    },
    data() {
        return {
            clientVersion: Version,
            serverVersion: ''
        }
    },
    computed: {
        userRoleDisplay: function () {
            return this.$store.getters.isLoggedIn ? this.$t(`role.${this.$store.getters.getUserRole}`) : ''
        },
        displayName: function () {
            return this.$store.getters.getUserDisplayName
        }
    },
    created() {
        this.getServerVersion();
    },
    methods: {
        setLang: function (event) {
            this.$store.commit('setLocale', event.target.textContent.toLowerCase())
            var route = this.$router.currentRoute
            this.$router.setTitle(route)
        },
        logout: function () {
            this.$store.commit('logout')
            this.$ncalayer.breakSession(null)
            this.$router.push('/login')
        },
        getServerVersion() {
            return this.$request.sendGetRequest(
                this,
                this.$appConfig.apiUrls.versions.server,
                version => this.serverVersion = version,
                error => console.error(error)
            );
        }
    }
}
</script>
<style>
#personDropdown > .dropdown-toggle::after {
    vertical-align: 1em;
}
</style>
